import { Form, Formik } from "formik";
import { APPLY_BUTTON_STYLE, RESET_BUTTON_STYLE } from "./reportCommon";
import { DEFAULT_HOOK_LOADER_FILTERS } from "./staticReportData";

const HookLoaderFilter = ({
  initialValues = DEFAULT_HOOK_LOADER_FILTERS,
  wardOptions = [],
  onSearch,
  onReset,
}) => (
  <Formik
    initialValues={initialValues}
    enableReinitialize
    onSubmit={(values) => onSearch?.(values)}
  >
    {({ values, setFieldValue, resetForm, handleSubmit }) => (
      <Form onSubmit={handleSubmit}>
        <div className="row align-items-end">
          <div className="col-md-3 mb-3">
            <label className="form-label">Ward</label>
            <select
              name="wardId"
              value={values.wardId}
              onChange={(event) => setFieldValue("wardId", event.target.value)}
              className="form-select bg-white"
            >
              <option value="">Select Ward</option>
              {wardOptions.map((ward) => (
                <option key={ward.wardId} value={ward.wardId}>
                  {ward.wardName}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3 mb-3">
            <label className="form-label">Vehicle No</label>
            <input
              type="text"
              name="vehicleNo"
              value={values.vehicleNo}
              onChange={(event) =>
                setFieldValue("vehicleNo", event.target.value)
              }
              className="form-control bg-white"
              placeholder="Enter vehicle no"
            />
          </div>

          <div className="col-md-3 mb-3">
  <label className="form-label">From Date &amp; Time</label>
  <input
    type="datetime-local"
    name="fromDate"
    value={values.fromDate}
    onChange={(event) =>
      setFieldValue("fromDate", event.target.value)
    }
    className="form-control bg-white"
  />
</div>

<div className="col-md-3 mb-3">
  <label className="form-label">To Date &amp; Time</label>
  <input
    type="datetime-local"
    name="toDate"
    value={values.toDate}
    min={values.fromDate || undefined}
    onChange={(event) =>
      setFieldValue("toDate", event.target.value)
    }
    className="form-control bg-white"
  />
</div>

          <div className="col-md-3 mb-3 d-flex gap-2">
            <button type="submit" style={APPLY_BUTTON_STYLE}>
              APPLY FILTERS
            </button>
            <button
              type="button"
              style={RESET_BUTTON_STYLE}
              onClick={() => {
            const resetValues = {
              wardId: "",
              vehicleNo: "",
              fromDate: "",
              toDate: "",
            };

            resetForm({ values: resetValues });
            onReset?.();
              }}
            >
              RESET
            </button>
          </div>
        </div>
      </Form>
    )}
  </Formik>
);

export default HookLoaderFilter;
